import { render, staticRenderFns } from "./tSiteType.vue?vue&type=template&id=72bff739&scoped=true"
import script from "./tSiteType.vue?vue&type=script&lang=js"
export * from "./tSiteType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bff739",
  null
  
)

export default component.exports